/**
 * Returns whether the current environment is a development or test environment.
 *
 * @returns `true` if the current environment is a development or test environment; `false` if it
 *          is a production environment
 */
export function isDevEnvironment(): boolean {
  return process.env.NODE_ENV === 'development';
}
